// Formatos compartidos del Buscaminas (juego, ranking y perfil)

// 83 456 ms → "1:23,45"; 9 870 ms → "9,87"
export function formatTime(ms: number): string {
  const cs = Math.floor(ms / 10);
  const m = Math.floor(cs / 6000);
  const s = Math.floor((cs % 6000) / 100);
  const frac = (cs % 100).toString().padStart(2, '0');
  return m > 0 ? `${m}:${s.toString().padStart(2, '0')},${frac}` : `${s},${frac}`;
}

// Reloj en partida: solo segundos para no distraer ("0:07", "1:23")
export function formatClock(ms: number): string {
  const total = Math.floor(ms / 1000);
  return `${Math.floor(total / 60)}:${(total % 60).toString().padStart(2, '0')}`;
}
